export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS'      : 'Applications',
            'DASHBOARDS'        : 'Dashboard',
            'SUPERADMIN'        : 'Administration',
            'ORGANIZATION'      : 'Organization',
            'MARKET'            : 'Market',
            'MARKET_LEVEL'      : 'Market Level',
            'USER_ROLE'         : 'User Role',
            'DISTRIBUTOR'       : 'Distributor',
            'CUSTOMER'          : 'Customer',
            'CHEMIST'           : 'Chemist',
            'DOCTOR'            : 'Doctor',
            'DOCTOR_VISIT'      : 'Doctor Visit',
            'PRODUCT'           : 'Product',
            'CAMPAIGN'          : 'Campaign',
            'ORDER_ALPHA'       : 'Order',
            'ORDER'             : 'Order',
            'SITE'             : 'Site',
            'INVOICE'           : 'Invoice',
            'DELIVERY_CHALLAN'  : 'Delivery Challan',
            'DELIVERY'          : 'Delivery',
            'MARKET_HIERARCHY'  : 'Market Structure',
            'SALES_CENTER'      : 'Sales Center',
            'MENU'             :  'Menu',
            'USER'              : 'User',
            'SURVEY'              : 'Survey',
            'EXPENSE_CLAIM'     : 'Explain Claim',
            'TOUR_PLAN'         : 'Tour Plan',
            'BANK_ACCOUNT'      : 'Bank Account',
            'PAYMENT'           : 'Payment',
            'PAYMENT_APPROVAL'  : 'Payment Approval',
            'ORDER_APPROVAL'    : 'Order Approval',
            'VISIT_APPROVAL'    : 'Visit Approval',
            'CUSTOMER_APPROVAL'    : 'Customer Approval',
            'TOURPLAN_APPROVAL'    : 'Tour Plan Approval',
            'EXPENSE_CLAIM_APPROVAL'    : 'Expense Claim Approval',
            'USER_LEAVE_APPROVAL'    : 'User Leave Approval',
            'DOCTOR_LEAVE_APPROVAL'    : 'Doctor Leave Approval',
            'ATTENDANCE'        : 'Attendance',
            'VISIT'             : 'Visit',
            'NOTICE'            : 'Notice',
            'EXPENSE'           : 'Expense',
            'DAILY_TA_DA'       : 'Daily TA/DA',
            'HOLIDAY'           : 'Holiday',
            'LOCATION'          : 'Tracking',
            'RETURN'            : 'Return',
            'REPORT'            : 'Report',
            'TARGET_ACHIEVEMENT': 'Target Achievement',
            'OTHERS'            : 'Others',
            'INSTITUTE'         : 'Institute',
            'PRESCRIPTION'      : 'Prescription',
            'TRAINING'         : 'Training',
            'STOCK'            : 'Stock',
            'SAMPLE_STOCK'     : 'Sample Stock'

        }
    }
};
